import React from "react";
const defaultContext = {
    state: { language: "en", status: "ok" },
    setState: () => { },
};
const I18n = React.createContext(defaultContext);
export default I18n;
